export default "__VITE_ASSET__Cc6UY9JF__"